import { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { AppContext } from '../context/AppContext';
import { OnboardingContext } from '../context/OnboardingContext';
import OnboardingLayout from '../ui/Layout/OnboardingLayout';
import LoginCard from '../ui/LoginCard';
import OnboardingProgress from '../ui/OnboardingProgress';
import ThemeAwareLogo from '../ui/ThemeAwareLogo';

import {
  AddressContainer,
  ConnectedContainer,
  ElectricVehicleContainer,
  EquipmentDetailsContainer,
  FinalisingContainer,
  IntroductionContainer,
  ManualAddressContainer,
  NotFoundContainer,
  PvSystemContainer,
  SolarDiverterContainer,
  SolarDiverterWarningContainer,
  SubscribedContainer,
  SubscriptionContainer,
  SuccessContainer,
  TariffContainer,
} from './Onboarding';
import AlphaessConnectionContainer from './Onboarding/Connection/AlphaessConnectionContainer';
import GivEnergyConnectionContainer from './Onboarding/Connection/GivEnergyConnectionContainer';
import GrowattConnectionContainer from './Onboarding/Connection/GrowattConnectionContainer';
import InstagenConnectionContainer from './Onboarding/Connection/InstagenConnectionContainer';
import MockInverterConnectionContainer from './Onboarding/Connection/MockInverterConnectionContainer';
import SolisConnectionContainer from './Onboarding/Connection/SolisConnectionContainer';
import SunsynkConnectionContainer from './Onboarding/Connection/SunsynkConnectionContainer';
import ExportLimitContainer from './Onboarding/ExportLimitContainer';
import SmartTariffContainer from './Onboarding/SmartTariffContainer';
import SmartTariffWarningContainer from './Onboarding/SmartTariffWarningContainer';
import SolarPanelGroupsContainer from './Onboarding/SolarPanelGroupsContainer';
import SolarPanelsContainer from './Onboarding/SolarPanelsContainer';

const OnboardingContainer = () => {
  const { progressPercentage } = useContext(OnboardingContext);
  const { subscriptionsDisabled } = useContext(AppContext);
  const theme = useTheme();
  return (
    <OnboardingLayout backgroundTint="blue" showSignOut={true}>
      <LoginCard>
        {theme.layout.showOrHideElements.onBoarding.showCompanyLogoInCard && (
          <Row>
            <Col className="px-lg-3 px-md-2 px-1 d-flex justify-content-center mb-3">
              <ThemeAwareLogo className="d-sm-block onboard-logo" alt="Company Logo" />
            </Col>
          </Row>
        )}
        {progressPercentage > 0 && <OnboardingProgress percentage={progressPercentage} />}
        <Switch>
          <Route path={['/onboarding', '/onboarding/introduction']} component={IntroductionContainer} exact />
          <Route path="/onboarding/address" component={AddressContainer} exact />
          <Route path="/onboarding/manual-address" component={ManualAddressContainer} exact />
          <Route path="/onboarding/smart-tariff" component={SmartTariffContainer} exact />
          <Route path="/onboarding/smart-tariff-warning" component={SmartTariffWarningContainer} exact />
          <Route path="/onboarding/tariff" component={TariffContainer} exact />
          <Route path="/onboarding/pv-system" component={PvSystemContainer} exact />
          <Route path="/onboarding/solar-panels" component={SolarPanelsContainer} exact />
          <Route path="/onboarding/solar-panels/details" component={SolarPanelGroupsContainer} exact />
          <Route path="/onboarding/solar-diverter" component={SolarDiverterContainer} exact />
          <Route path="/onboarding/solar-diverter-warning" component={SolarDiverterWarningContainer} exact />
          <Route path="/onboarding/electric-vehicle" component={ElectricVehicleContainer} exact />
          <Route path="/onboarding/equipment-details" component={EquipmentDetailsContainer} exact />
          <Route path="/onboarding/export-limit" component={ExportLimitContainer} exact />
          <Route path="/onboarding/connection/alphaess" component={AlphaessConnectionContainer} exact />
          <Route path="/onboarding/connection/givenergy" component={GivEnergyConnectionContainer} exact />
          <Route path="/onboarding/connection/growatt" component={GrowattConnectionContainer} exact />
          <Route path="/onboarding/connection/instagen" component={InstagenConnectionContainer} exact />
          <Route path="/onboarding/connection/sunsynk" component={SunsynkConnectionContainer} exact />
          <Route path="/onboarding/connection/solis" component={SolisConnectionContainer} exact />
          <Route path="/onboarding/connection/mock-inverter" component={MockInverterConnectionContainer} exact />
          <Route path="/onboarding/connected" component={ConnectedContainer} exact />
          {!subscriptionsDisabled && <Route path="/onboarding/subscription" component={SubscriptionContainer} exact />}
          {!subscriptionsDisabled && <Route path="/onboarding/subscribed" component={SubscribedContainer} exact />}
          <Route path="/onboarding/finalising" component={FinalisingContainer} exact />
          <Route path="/onboarding/success" component={SuccessContainer} exact />
          <Route path="/onboarding/not-found" component={NotFoundContainer} exact />
          <Route>
            <Redirect to="/onboarding/not-found" />
          </Route>

          {/*<Route
              path="/onboarding/error"
              component={ErrorContainer}
              exact
            /> */}
        </Switch>
      </LoginCard>
    </OnboardingLayout>
  );
};

export default OnboardingContainer;
